<template>
  <div
    v-show="boardOpen"
    class="display-flex project-board"
    :style="{ 
        width: (windowWidth >= 992 && !expBoard ?'25%': windowWidth >= 992 && expBoard ? '39%' : '100%'), 
        position: 'relative'
      }"
  >
    <template v-if="boardOpen">
      <wg-modal
        v-if="showNewContentDialog"
        :width="windowWidth > 700 ? '700px' : '90%'"
        @closeModal="showNewContentDialog = false"
      >
        <div
          class="com-anm22-app-text-l"
          slot="header"
        >{{ $anm22.strLang(lang, 'Add content', 'Aggiungi elemento') }}</div>
        <new-project-feed :projectId="projectId" slot="body"></new-project-feed>
      </wg-modal>
      <div v-if="windowWidth >= 992" class="wg-row" style="flex-wrap:nowrap;align-items:center;">
        <div style="font-size:22px;">{{ $anm22.strLang(lang, 'Board', 'Bacheca') }}</div>
        <div class="horizontal-width-div" style="width:23px;"></div>
        <img
          v-if="!expBoard"
          @click="$parent.expBoard = true"
          :title=" $anm22.strLang(lang, 'Enlarge board size', 'Aumenta dimensione bacheca')"
          :src="$anm22.icons.getWorldIcon('expandBoard')"
          class="com-anm22-app-img-fixed-height-l"
          style="cursor:pointer;margin:auto;height:17px;opacity:0.8;"
        />
        <img
          v-if="expBoard"
          @click="$parent.expBoard = false"
          :title=" $anm22.strLang(lang, 'Decrease board size', 'Diminuisci dimensione bacheca')"
          :src="$anm22.icons.getWorldIcon('resizeBoard')"
          class="com-anm22-app-img-fixed-height-l"
          style="cursor:pointer;margin:auto;height:17px;opacity:0.8;"
        />
        <div class="vertical-height-div" style="height:10px;"></div>
      </div>
      <div class="project-board-body">
        <div v-if="loading" class="wg-row" style="justify-content:center;">
          <vue-simple-spinner size="medium" line-fg-color="rgb(136, 237, 124)" />
        </div>
        <template v-else>
          <template v-if="!board && !offline">
            <input
              type="button"
              :value="$anm22.strLang(lang, 'Create board', 'Crea bacheca')"
              @click="createBoard"
            />
          </template>
          <template v-else>
            <div v-if="msgs.length === 0" style="margin:auto;">
              <img
                :src="$anm22.icons.getWorldIcon('questionAnswerFilled')"
                style="width:60px;display:block;margin:20px auto;opacity:0.3"
              />
              <div
                style="text-align:center;max-width:400px;font-size:16px;color:#666;margin:0 auto;"
              >{{ $anm22.strLang(lang, "No feed", "Nessun feed") }}</div>
              <div
                style="text-align:center;max-width:400px;font-size:14px;color:#999;margin:0 auto 50px auto;"
              >{{ $anm22.strLang(lang, "Create your first feed", "Crea il tuo primo feed") }}</div>
            </div>
            <div v-else class="board-msg-container">
              <template v-for="(msg, index) in msgs.sort((a,b) => a.ts - b.ts)">
                <!-- Controllo se è cambiato giorno -->
                <div
                  :key="'sep'+index"
                  v-if="(index === 0) || (index > 0 && $moment.unix(msg.ts).isAfter($moment.unix(msgs[index - 1].ts), 'day'))"
                  class="wg-row board-day-sep"
                >
                  {{ $moment.unix(msg.ts).isSame(now, 'day')
                  ? $anm22.strLang(lang, 'Today', 'Oggi')
                  : ($moment.unix(msg.ts).isSame(now, 'year')?$moment.unix(msg.ts).format('DD MMM'):$moment.unix(msg.ts).format('DD MMM YYYY'))
                  }}
                </div>
                <board-msg
                  :key="'msg-'+index"
                  :msg="msg"
                  :projectId="projectId"
                  :printUser="index > 0 ? msg.user !== msgs[index - 1].user : true"
                ></board-msg>
              </template>
            </div>
            <div class="wg-row board-msg-input">
              <div class="feed-btn" @click="showNewContentDialog = true">
                <img
                  style="margin-top:5px;margin-left:3px;"
                  :src="$anm22.icons.getWorldIcon('addWhite')"
                />
              </div>
            </div>
          </template>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BoardMsg from "./ProjectBoardMsg.vue";
import NewProjectFeed from "./NewProjectFeed.vue";
import Spinner from "vue-simple-spinner";

export default {
  props: {
    projectId: [Number, String],
    expBoard: Boolean,
    boardOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showNewContentDialog: false,
      loading: false,
      now: this.$moment(),
      msgString: "",
      lastIndex: 0,
      lastCheck: null,
      temp: null,
      updateInterval: null
    };
  },
  computed: {
    ...mapState({
      offline: state => state.offline.isOffline,
      user: state => state.auth.user,
      lang: state => state.lang,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    board() {
      return this.$store.getters["messageChannels/get"](this.project.board);
    },
    msgs() {
      return this.$store.getters["messages/getByChannel"](
        this.board.idWorldMessageChannel
      );
    }
  },
  methods: {
    loadData() {
      Promise.all([
        this.$store.dispatch(
          "messageChannels/load",
          this.$vlf("messageChannels")
        ),
        this.$store.dispatch("messages/load", this.$vlf("messages")),
        this.$store.dispatch(
          "feedBoardAssocs/load",
          this.$vlf("feedBoardAssocs")
        )
      ])
        .then(() => {
          this.loading = false;
        })
        .catch(error => console.log(error));
    },
    checkUpdates() {
      if (!this.$store.getters["offline/isOffline"] && this.board) {
        this.$http
          .get(
            "project/checkMessages?idProject=" +
              this.project.idWorldProject 
          )
          .then(response => {
            return this.$store.dispatch("messages/update", {
              vlf: this.$vlf("messages"),
              objs: response.data.messages,
              cleanFilters:[m=> m.channel == this.board.idWorldMessageChannel]
            });
          })
          .then(() => {
            // this.lastIndex = this.msgs.length;
          })
          .catch(error => console.log(error));
      }
    },
    createBoard() {
      this.$http
        .post("project/createBoard", {
          projectId: this.project.idWorldProject
        }, {
          withCredentials: true
        })
        .then(response => {
          if (response.data) {
            let project = { ...this.project };
            project.board = response.data.board.idWorldMessageChannel;
            Promise.all([
              this.$store.dispatch("projects/update", {
                vlf: this.$vlf("projects"),
                objs: [project]
              }),
              this.$store.dispatch("messageChannels/update", {
                vlf: this.$vlf("messageChannels"),
                objs: [response.data.board]
              })
            ])
              .then(() => {
                this.$nextTick(() => {
                  setInterval(this.checkUpdates, 10000);
                });
              })
              .catch(error => console.log(error));
          }
        })
        .catch(error => console.log(error));
    }
  },
  created() {
    this.loading = true;
    this.loadData();
    this.$http
      .get("project/board?idProject=" + this.project.idWorldProject)
      .then(response => {
        if (response.data) {
          Promise.all([
            this.$store.dispatch("messageChannels/update", {
              vlf: this.$vlf("messageChannels"),
              objs: [response.data.board]
            }),
            this.$store.dispatch("messages/update", {
              vlf: this.$vlf("messages"),
              objs: response.data.messages,
              cleanFilters:[m=> m.channel == response.data.board.idWorldMessageChannel]
            }),
            this.$store.dispatch("feedBoardAssocs/update", {
              vlf: this.$vlf("feedBoardAssocs"),
              objs: response.data.assocs
            })
          ])
            .then(() => {
              // this.lastIndex = this.msgs.length;
              this.loading = false;
            })
            .catch(error => console.log(error));
        }
      })
      .catch(error => console.log(error));
  },
  mounted() {
    this.$nextTick(() => {
      this.updateInterval = setInterval(this.checkUpdates, 40000);
    });
  },
  destroyed() {
    clearInterval(this.updateInterval);
  },
  components: {
    BoardMsg,
    "vue-simple-spinner": Spinner,
    "new-project-feed": NewProjectFeed
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../world/libs/anm22_web_graphics/v1/scss/_variables.scss";
.project-board {
  height: calc(100vh - 108px);
  padding: 10px;
}
.feed-btn {
  width: 50px;
  height: 50px;
  box-shadow: 0 2px 5px #666;
  cursor: pointer;
  position: fixed;
  right: 25px;
  bottom: 11px;
  padding: 9px;
  box-sizing: border-box;
  color: #fff;
  border-radius: 30px;
  text-align: center;
  font-size: 34px;
  line-height: 1.1;
  background-color: lightgray;
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  z-index: 10;
}
.project-board-body {
  overflow: auto;
  height: calc(100% - 80px);
  width: 100%;
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    opacity: 0;
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #78909c;
    border: 3px solid transparent;
    border-radius: 9px;
    background-clip: content-box;
  }
}
@media screen and (max-width: 991px) {
  .project-board {
    height: calc(90vh - 91px);
    padding: 0;
    border: none;
  }
  .project-board-body {
    height: calc(100% - 49px);
  }
}
.board-day-sep {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  color: #999;
}
.board-msg-input {
  position: absolute;
  flex-wrap: nowrap;
  align-items: center;
  bottom: 0;
  left: 0;
  //background-color: #fff;
  height: 40px;
  z-index: 10;
  // font-size: 0;
  // text-align: left;
  // padding: 5px;
  // border-radius: 2px;
  & textarea {
    align-self: flex-end;
    border-radius: 5px;
    border: 1px solid #ddd;
    font-size: 14px;
    width: calc(100% - 32px);
    max-width: none;
    margin: 0 0 10px 2px;
    padding: 5px 8px 5px 5px;
    height: 30px;
    max-height: 70px;
    overflow: auto;
    outline: 0;
    border-radius: 5px;
    border: 1px solid #ddd;
    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    &::-webkit-scrollbar-track {
      opacity: 0;
      width: 10px;
      height: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #78909c;
      border: 3px solid transparent;
      border-radius: 9px;
      background-clip: content-box;
    }
  }
  & img {
    width: 25px;
    height: 25px;
    opacity: 0.8;
    margin: 0 0 10px auto;
    cursor: pointer;
  }
}
</style>
